import React from 'react';
import { CustomLabelMediumSmallBold , CustomLabelMediumBold, CustomLabelMediumRegular} from '../../common/CustomLabel';
import { 
  Grid, 
  Typography,
  Box
} from '@mui/material';

const ProcessSection = ({title, tagline, svg}) => {

  return (
    <Grid container>
      <Grid item xs={12} md={12} sx={{padding: {xs: "20px", md: "20px 60px"}, backgroundColor: "#FBF6FF"}}>
        <Grid container justifyContent="center" alignItems="center" direction="column" textAlign="center">
            <CustomLabelMediumBold text={title} color={"#5E17EB"}/>
            <CustomLabelMediumRegular normal={true} text={tagline} />
        </Grid>
        <Grid item xs={12} sx={{ padding: 0, marginTop : {xs :"0px" , md : "40px"} }}>
          <Grid container justifyContent={"center"} sx={{ paddingTop : {xs :"0px" , md : "40px"},  paddingBottom : {xs :"0px" , md : "80px"}, height: "100%" , transform: { sm: 'scale(0.8)', md: 'scale(0.8)', lg: 'scale(1.1)', xlg: 'scale(1.2)' } }} >
            <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' }, marginTop: {xs: "20px", md: "0px"} }}>
              {svg[1]} {/* ProcessSvgMob */}
            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
              {svg[0]} {/* ProcessSvg */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProcessSection;
